<template>
  <div class="UpdatePhoneBox">
    <van-popup v-model="showPopup" position="bottom" duration="0.2">
      <div class="popoverContent">
        <div class="title">
          验证身份
          <img src="@/assets/images/drawerClose.png" alt="" class="drawerClose" @click="showPopup = false">
        </div>
        <input type="text" class="input" :value="publicPage.phone" disabled>
        <div class="codeBox">
          <input type="text" class="input" v-model="code" ref="codeInput" maxlength="6" placeholder="请输入验证码">
          <div class="getCode" @click="getCode">{{count ? `${count}s后重试` : '获取验证码'}} </div>
        </div>

        <div class="buttonGroup">
          <div class="submit" @click="onDetermine">确认</div>
        </div>
        <div class="tip" @click="goFace">收不到短信验证码？</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'UpdatePhone',
  props: {
    value: {
      type: Boolean,
    },
    submit: {
      type: Function
    },
    goFace: {
      type: Function
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  data() {
    return {
      invoiceDetailList: [],
      oneYearAmount: '',
      updateTime: '',
      showPopup: false,
      count: 0,
      code: '',
      timer: null
    };
  },
  mounted() {
  },
  watch: {
    value: {
      handler(newValue) {

      },
      immediate: true,
    },
  },
  methods: {
    
    onClose() {
      this.$emit('input', false);
    },
    getCode() {
      if (this.count !== 0) {
        return
      }
      this.$refs.codeInput.focus()
      this.$api.PublicPage.getSmsWithLogin({ type: '10' }).then(res => {
        if (!res.success) {
          return Toast(res.returnMessage)
        }
        Toast('发送成功，请查收短信')
        this.count = 60
        this.timer = setInterval(() => {
          console.log(this.count, '=cumm')
          if (this.count > 0) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      })
    },
    onDetermine() {
      if (!this.code) {
        return Toast('请输入验证码')
      }
      this.$api.PublicPage.verifySMSWithLogin({ captcha: this.code, type: '10' }).then(res => {
        if (!res.success) {
          return Toast(res.returnMessage)
        }
        this.showPopup = false
        setTimeout(() => {
          this.submit()
        }, 500);
      })

    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="scss" scoped>
.popoverContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  .codeBox {
    display: flex;
    align-items: center;
    .input {
      flex: 1;
    }
    .getCode {
      margin-left: 10px;
      width: 80px;
    }
  }
  .buttonGroup {
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: 40px;
    margin-top: 10px;
    .submit {
      background: #ff6538;
      border-radius: 4px;
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
      height: 44px;
    }
  }
  .tip{
    color: #ff6538;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
  .input {
    margin-top: 10px;
    height: 35px;
    border: none;
    background: #fff;
    margin-top: 10px;
    color: #1c2438;
  }
  .input::placeholder {
    font-size: 14px;
    font-weight: normal;
  }
}
.title {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px 8px 0 0;
  color: #1c2438;
  font-size: 16px;
  .drawerClose {
    width: 20px;
    height: 20px;
  }
}
// >>> .van-popup--bottom {
//   z-index: 10000 !important;
//   border-radius: 8px 8px 0 0;
// }
</style>
